module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "overlay": false,
      "loading": _vm.loading || _vm.parentLoading
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('h1', {
    staticClass: "txtCenter",
    staticStyle: {
      "font-size": "xx-large"
    }
  }, [_vm._v(_vm._s(_vm.isSsoSystemNew ? "Add a new SSO system" : "Edit SSO system" + _vm.ssoSystem.name))]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "action": ""
    },
    on: {
      "submit": _vm.validateForm
    }
  }, [(_vm.validationErrors.length > 0) ? _c('div', {
    staticClass: "validation-errors"
  }, _vm._l((_vm.validationErrors), function(error, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(error))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.name),
      expression: "ssoSystem.name"
    }],
    staticClass: "full-width",
    attrs: {
      "id": "prop-name",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-name"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.type.id),
      expression: "ssoSystem.type.id"
    }],
    staticClass: "full-width",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ssoSystem.type.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableTypes), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id,
        "selected": _vm.ssoSystem.type.id === type.id
      }
    }, [_vm._v("\n                            " + _vm._s(type.label) + "\n                        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-1"
    }
  }, [_vm._v("IDP Single Sign On Service Url")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.idpSingleSignOnServiceUrl),
      expression: "ssoSystem.configuration.idpSingleSignOnServiceUrl"
    }],
    staticClass: "full-width",
    attrs: {
      "id": "prop-configuration-1",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.idpSingleSignOnServiceUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.idpSingleSignOnServiceUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-2"
    }
  }, [_vm._v("IDP Entity ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.idpEntityId),
      expression: "ssoSystem.configuration.idpEntityId"
    }],
    staticClass: "full-width",
    attrs: {
      "id": "prop-configuration-2",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.idpEntityId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.idpEntityId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-3"
    }
  }, [_vm._v("IDP Public Certificate")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.idpX509cert),
      expression: "ssoSystem.configuration.idpX509cert"
    }],
    staticClass: "full-width",
    attrs: {
      "id": "prop-configuration-3",
      "type": "text",
      "rows": "10",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.idpX509cert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.idpX509cert = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-4"
    }
  }, [_vm._v("SP Entity ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.spEntityId),
      expression: "ssoSystem.configuration.spEntityId"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": "will be generated automatically",
      "id": "prop-configuration-4",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.spEntityId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.spEntityId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-5"
    }
  }, [_vm._v("SP Assertion Consumer Service URL")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.spAssertionConsumerServiceUrl),
      expression: "ssoSystem.configuration.spAssertionConsumerServiceUrl"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": "will be generated automatically",
      "id": "prop-configuration-5",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.spAssertionConsumerServiceUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.spAssertionConsumerServiceUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-configuration-6"
    }
  }, [_vm._v("SP Single Logout Service URL")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.configuration.spSingleLogoutServiceUrl),
      expression: "ssoSystem.configuration.spSingleLogoutServiceUrl"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": "will be generated automatically",
      "id": "prop-configuration-6",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ssoSystem.configuration.spSingleLogoutServiceUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssoSystem.configuration.spSingleLogoutServiceUrl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label",
    attrs: {
      "for": "prop-domains"
    }
  }, [_vm._v("Domains covered")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('ul', _vm._l((_vm.ssoSystem.domains), function(domain) {
    return _c('li', {
      key: domain.name,
      staticClass: "reduced-width"
    }, [_vm._v("\n                            @" + _vm._s(domain.name) + "\n                            "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.removeDomain(domain.name);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDomain),
      expression: "newDomain"
    }],
    staticClass: "reduced-width",
    attrs: {
      "id": "prop-domains",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newDomain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDomain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.addDomain();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssoSystem.allowInternalAuth),
      expression: "ssoSystem.allowInternalAuth"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ssoSystem.allowInternalAuth) ? _vm._i(_vm.ssoSystem.allowInternalAuth, null) > -1 : (_vm.ssoSystem.allowInternalAuth)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ssoSystem.allowInternalAuth,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ssoSystem.allowInternalAuth = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ssoSystem.allowInternalAuth = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ssoSystem.allowInternalAuth = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Allow internal authentication for some users within these domains")])])]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer"
  }, [_c('button', {
    staticClass: "btn block pointer uppercase save"
  }, [_vm._v("save")])])])]), _vm._v(" "), (false) ? _c('template', {
    slot: "overlay"
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27f9a193","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/sso-system/SsoSystemFormModal.vue
// module id = 3088
// module chunks = 0